import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { getCompaniesLibraries } from 'api/company';

import AutoCompleteInput from './AutocompleteInput';

const SearchByLibraryName = ({ filterBy, onSelected, placeholder, defaultValue = null }) => {
  const [nameSelected, setNameSelected] = useState(null);

  useEffect(() => {
    if (defaultValue) {
      setNameSelected({
        label: defaultValue,
        value: defaultValue,
      });
    } else setNameSelected(null)
  }, [defaultValue]);

  const onSearch = async (value) => {
    if (value.length > 1) {
      const { status, data } = await getCompaniesLibraries({ [filterBy]: value, page: 1, page_size: 10 });
      if (status === 200) {
        return data?.results?.map((item) => ({
          label: item[filterBy],
          value: item[filterBy],
        }));
      }
    }
    return [];
  };

  return (
    <div className="container-search searchLibrary">
      <AutoCompleteInput
        placeholder={placeholder}
        defaultOptions={nameSelected ? [nameSelected] : []}
        defaultValue={nameSelected}
        onSelect={onSelected}
        onSearch={onSearch}
        isClearable={false}
      />
    </div>
  );
};

SearchByLibraryName.propTypes = {
  filterBy: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onSelected: PropTypes.func.isRequired,
  defaultName: PropTypes.object,
};

export default SearchByLibraryName;
